import * as S from './style';
import { useState } from 'react';
import uuid from 'react-uuid';
interface InputSelectProps {
	options: { value: string; label: string }[];
	defaultValue?: string;
	selectedOption: string;
	setSelectedOption: (label: string) => void;
}
const InputSelect = ({ options, selectedOption, setSelectedOption, defaultValue = '' }: InputSelectProps) => {
	const [isOpen, setIsOpen] = useState(false);

	const handleOptionClick = (value: string) => {
		setSelectedOption(value);
		setIsOpen(false);
	};
	return (
		<S.DropdownContainer>
			<S.SelectBox onClick={() => setIsOpen(!isOpen)} isOpen={isOpen} className="dropdown-container">
				<S.SelectedText hasValue={selectedOption !== ''}>{selectedOption === '' ? defaultValue : selectedOption}</S.SelectedText>
				<S.ArrowIcon isOpen={isOpen}>
					<svg xmlns="http://www.w3.org/2000/svg" width="12" height="6" viewBox="0 0 12 6" fill="none">
						<path
							d="M10.6641 1.00033L6.84592 4.81847C6.37729 5.28709 5.6175 5.28709 5.14887 4.81846L1.33073 1.00033"
							stroke="#343A40"
							strokeWidth="1.2"
							strokeLinecap="round"
						/>
					</svg>
				</S.ArrowIcon>
			</S.SelectBox>
			<S.OptionsList isOpen={isOpen} className="dropdown-container">
				{options.map((option) => (
					<S.OptionItem key={uuid()} onClick={() => handleOptionClick(option.value)}>
						{option.label}
					</S.OptionItem>
				))}
			</S.OptionsList>
		</S.DropdownContainer>
	);
};
export default InputSelect;
